/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

window.dataLayer = window.dataLayer || [];

function getDomain(siteUrlArray) {
  var result = "";
  if (siteUrlArray[0] === "local-blog") {
    result = {
      global: 'https://local.netwrix.com/',
      local: 'https://local.netwrix.fr/'
    };
  } else if (siteUrlArray[0] === "dev3-blog") {
    result = {
      global: 'https://dev3.netwrix.com/',
      local: 'https://dev3.netwrix.fr/'
    };
  } else {
    result = {
      global: 'https://www.netwrix.com/',
      local: 'https://www.netwrix.fr/'
    };
  }

  return result;
}

function currentURL() {
  return window.location.protocol + '/' + window.location.hostname + window.location.pathname;
}

var siteUrl = window.location.hostname.split(".");
var domain = getDomain(siteUrl);
var isABTest = false;
var widthMobileDevice = 768;


/**
 * Fires when click to link for copy URL to clipboard.
 * @param {Event} clickEvent
 */
function copyLink(clickEvent) {
  var input = document.createElement('input');
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.value = window.location.href;

  // input.focus();
  input.select();

  var htmlLink = clickEvent.target;
  var isSuccessful = document.execCommand('copy');
  if (isSuccessful) {
    htmlLink.innerText = 'Copied!';
  } else {
    htmlLink.innerText = 'Copy to clipboard is not supported';
  }

  input.remove();
}

function initSocialShareButtons() {
  var sharingButtons = [].slice.call(document.querySelectorAll('.social-button-list-js > .item'),0);
  sharingButtons.forEach(function(buttonItem) {
    buttonItem.addEventListener('click', function(event) {
      event.preventDefault();

      var social = this.dataset.social || null;
      var path = window.location.href;
      var title = encodeURIComponent(document.title);

      var url = '';
      switch (social) {
        case 'facebook':
          url = 'https://www.facebook.com/sharer.php';
          url += '?u=' + path;
          break;

        case 'linkedin':
          url = 'https://www.linkedin.com/shareArticle';
          url += '?mini=true';
          url += '&url=' + path;
          url += '&title=' + title;
          break;

        case 'twitter':
          url = 'https://twitter.com/intent/tweet';
          url += '?url=' + path;
          url += '&text=' + title;
          break;

        case 'reddit':
          url = 'https://reddit.com/submit';
          url += '?url=' + path;
          url += '&title=' + title;
          break;
      }

      window.open(url, '', 'toolbar=0,menubar=no,status=0,width=600,height=480');
    });
  });
}


/**
 * Subscription form in modal window
 */
var subscribeModalEl = document.getElementById("subscribe-modal");

(function($) {

  function subscribeModalOpen(open) {

    if (subscribeModalEl) {
      subscribeModalEl.classList.add("is-active");

      $.cookie('subscribeState', 1, {
        expires: 9999,
        path: "/"
      });

      // GA event
      if (open === 'menu') {
        var gtmCategory = 'Subscription pop-up upper menu';
      } else {
        var gtmCategory = 'Subscription pop-up';
      }

      window.dataLayer.push({
        'event': 'subscribeModal',
        'gtmCategory': gtmCategory,
        'gtmAction': 'view'
      });
    }
  }

  function subscribeModalClose() {
    subscribeModalEl.classList.remove("is-active");

    if ($.cookie('subscribeClose') == 0) {
      $.cookie('subscribeTimeClose', new Date().getTime(), {
        expires: 9999,
        path: "/"
      });
    }

    $.cookie('subscribeClose', 1, {
      expires: 9999,
      path: "/"
    });
    $.cookie('subscribeState', 0, {
      expires: 9999,
      path: "/"
    });
  }

  function subscribeFormSubmit() {
    var $form = subscribeModalEl.querySelector('.subscribe-form');
    var $thankYou = subscribeModalEl.querySelector('.modal-typ');
    var $input = subscribeModalEl.querySelector('input[name="email"]');
    var $button = subscribeModalEl.querySelector('.email-subscription-modal-js');
    var host = window.location.host;

    $button.disabled = true;

    $.ajax({
      type: "POST",
      url: domain.global + "additionalservice/checkemail",
      cache: false,
      data: {
        email: $input.value
      },
      success: function (data) {
        data = JSON.parse(data);
        if (data.status === 0) {
          var dataPost = {
            email: $input.value,
            prodtype: "Subscription",
            product_code: "none",
            lead_comment: "Subscribed to updates on " + host,
            init: "DiteUla3LANDW",
            leadWebsource: "blog",
            displayName: "Blog",
            lead_description: "Blog_FR",
            override_cookie_nwf_cid: "7010g000001YZB6",
            "event-page-url": currentURL(),
          };

          $.ajax({
            type: "POST",
            url: domain.global + "landing/createlead",
            cache: false,
            data: dataPost,
            success: function () {
              $thankYou.style.display = 'block';
              $form.style.display = 'none';
              var securityInfo = subscribeModalEl.querySelector('.security-info');
              securityInfo.style.display = 'none';
              //$(".modal-close-js").removeClass("modal-close-js");

              if (window.innerWidth < widthMobileDevice && isMobile) {
                setTimeout(function () {
                  subscribeModalEl.classList.remove("is-active");
                }, 2000);
              }

              window.dataLayer.push({
                'event': 'subscribeModal',
                'gtmAction': 'submit'
              });

              $.cookie("subscribeSubmit", 1, {
                expires: 9999,
                path: "/"
              });
            }
          });

        } else {
          $form.classList.add('has-error');
          $button.disabled = false;

          var textInputPopover;
          if ($input._tippy) {
            textInputPopover = $input._tippy;
          } else {
            textInputPopover = tippy($input, {
              content: "Saisissez votre e-mail professionnel.",
              theme: "nwx-error",
              trigger: "manual"
            });
          }

          textInputPopover.show();

          $input.addEventListener('focus', function () {
            $form.classList.remove('has-error');
            textInputPopover.hide();
          });

          setTimeout(function () {
            $form.classList.remove('has-error');
            textInputPopover.hide();
          }, 5000);

        }
      }
    });
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    "common": {
      init: function() {
        // JavaScript to be fired on all pages

        function slideoutInit() {
          function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf("MSIE ");

            if (msie > 0) {
              // IE 10 or older => return version number
              return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            var trident = ua.indexOf("Trident/");
            if (trident > 0) {
              // IE 11 => return version number
              var rv = ua.indexOf("rv:");
              return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            var edge = ua.indexOf("Edge/");
            if (edge > 0) {
              // Edge (IE 12+) => return version number
              return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
          }

          var slideout;
          var $openMenuBtn = $(".show-menu-js");
          var $closeMenuBtn = $(".close-menu-js");

          /* Fix for IE */
          if (detectIE()) {
            $(".slideout-menu").css("z-index", "100");
          }
          /* End fix */

          /* Close Slideout Menu */
          function close(eve) {
            if (eve !== undefined) {
              eve.preventDefault();
            }

            slideout.close();
          }

          /* End Close Slideout Menu */

          $(window).on("resize", function() {
            if ((slideout !== undefined) && (slideout.isOpen()) && $(window).outerWidth() > 1259) {
              close();
            }
          });

          slideout = new Slideout({
            "panel": document.querySelector(".slideout-panel-js"),
            "menu": document.querySelector(".mobile-menu-panel-js"),
            "padding": 256,
            "touch": false
          });

          slideout
            .on("beforeopen", function() {
              this.menu.classList.add("open");
              this.panel.classList.add("slideout-panel-open");
              $closeMenuBtn.removeClass("hidden");
            })
            .on("open", function() {
              this.panel.addEventListener("click", close);
            })
            .on("beforeclose", function() {
              this.panel.classList.remove("slideout-panel-open");
              this.panel.removeEventListener("click", close);
              $closeMenuBtn.addClass("hidden");
            })
            .on("close", function() {
              this.menu.classList.remove("open");
              $closeMenuBtn.addClass("hidden");
            });

          $openMenuBtn.on("click", function() {
            slideout.open();
          });

          $closeMenuBtn.on("click", close);
        }
        function initSearchBlockTop() {
          var $searchNavTop = $("#search-navigationtop");
          var $searchTop = {
            button: $searchNavTop.find(".search-btn-js"),
            form: $searchNavTop.find(".search-form-js"),
            input: $searchNavTop.find(".search-input-js"),
            subscribeBlockTop: $("#subscribe-item"),
            contactBlockTop: $("#contact-item"),
            searchBlockTop: $("#search-item"),
          };
          // show search field on desktop
          $searchTop.button.on("click", function (e) {
            e.preventDefault();
            $searchTop.form.fadeIn("fast", function () {
              $searchTop.input.focus();
            });
          });
          // hide search field on desktop
          $searchTop.input.on("blur", function () {
            $searchTop.form.fadeOut("fast", function () {
              $searchTop.subscribeBlockTop.fadeIn("fast");
              $searchTop.contactBlockTop.fadeIn("fast");
              $searchTop.searchBlockTop.fadeIn("fast");
            });
          });
        }
        function initSearchBlock() {
          var $searchNav = $("#search-navigation");
          var $search = {
            "button": $searchNav.find(".search-btn-js"),
            "form": $searchNav.find(".search-form-js"),
            "input": $searchNav.find(".search-input-js"),
            "subscribeBlock": $("#subscribe-item"),
            "contactBlock": $("#contact-item"),
            "searchBlock": $("#search-item")
          };

          // show search field on desktop
          $search.button.on("click", function(e) {
            e.preventDefault();

            $search.subscribeBlock.fadeOut("fast");
            $search.contactBlock.fadeOut("fast");
            $search.searchBlock.fadeOut("fast");

            $search.form.fadeIn("fast", function() {
              $search.input.focus();
            });
          });

          // hide search field on desktop
          $search.input.on("blur", function() {
            $search.form.fadeOut("fast", function() {
              $search.subscribeBlock.fadeIn("fast");
              $search.contactBlock.fadeIn("fast");
              $search.searchBlock.fadeIn("fast");
            });
          });
        }

        function insertLazyLink(url) {
          var lineEl = document.createElement("link");
          lineEl.type = "text/css";
          lineEl.href = url;
          lineEl.rel = "stylesheet";

          var otherLink = document.getElementsByTagName("link")[0];
          if (otherLink) {
            otherLink.parentNode.insertBefore(lineEl, otherLink);
          } else {
            otherLink.parentNode.appendChild(otherLink);
          }
        }

        function initGoToUp() {
          var $goToUpElem = $("#go-to-up");
          var $body = $("body, html");

          function showPanel() {
            if (!$goToUpElem.hasClass("show")) {
              $goToUpElem.addClass("show");
            }
          }

          function hidePanel() {
            if ($goToUpElem.hasClass("show")) {
              $goToUpElem.removeClass("show");
            }
          }

          function getCurrentPosition(offsetY, total) {
            return offsetY / total;
          }

          $goToUpElem.on("click", function() {
            $body.animate({scrollTop: 0}, 800);
          });

          var totalHeight = document.body.clientHeight;
          var currentScreenWidth = window.innerWidth;

          var current = getCurrentPosition(window.pageYOffset, totalHeight);
          if (current > 0.1 && currentScreenWidth > 1260) {
            showPanel();
          }

          $(window).on("resize", function() {
            currentScreenWidth = window.innerWidth;
          });

          // need for set Delay to fire scroll-event
          var timer;
          $(window).scroll(function() {
            if (timer) {
              window.clearTimeout(timer);
            }

            timer = window.setTimeout(function() {
              var current = getCurrentPosition(window.pageYOffset, totalHeight);

              if (current > 0.1 && currentScreenWidth > 1260) {
                showPanel();
              } else if (current <= 0.1) {
                hidePanel();
              }
            }, 500);
          });
        }

        // @TODO need rework mobile menu
        function customMobileMenu() {
          console.log("clk");
          var showMenuButton = document.querySelector(".show-menu-js");
          var mainBlock = document.querySelector(".slideout-panel");
          var menu = document.querySelector(".mobile-menu-panel");

          showMenuButton.addEventListener("click", function() {
            mainBlock.classList.add("slideout-panel-open");
            menu.classList.add("slideout-open");
          });
        }

        /* subscribe modal */

        // Update deprecated cookies
        var subscribeSubmit = $.cookie('subscribeSubmit'),
          subscribeClose = $.cookie('subscribeClose'),
          subscribeTimeClose = $.cookie('subscribeTimeClose');

        // Is the user subscribed
        if (subscribeSubmit === undefined) {
          if ($.cookie('subcribeModal') == 1) {
            subscribeSubmit = 1;
          } else {
            subscribeSubmit = 0;
          }

          $.cookie('subscribeSubmit', subscribeSubmit, {
            expires: 9999,
            path: "/"
          });
        }

        // Did the user close the modal
        if (subscribeClose === undefined) {
          if ($.cookie('smc') == 1) {
            subscribeClose = 1;
          } else {
            subscribeClose = 0;
          }

          $.cookie('subscribeClose', subscribeClose, {
            expires: 9999,
            path: "/"
          });
        }

        // Time to close the subscription window
        if (subscribeTimeClose === undefined) {
          if ($.cookie('uvt') !== undefined) {
            subscribeTimeClose = $.cookie('uvt');
          } else {
            subscribeTimeClose = 0;
          }

          $.cookie('subscribeTimeClose', subscribeTimeClose, {
            expires: 9999,
            path: "/"
          });
        }

        // Subscription window state
        $.cookie('subscribeState', 0, {
          expires: 9999,
          path: "/"
        });


        var $subscribeForm = subscribeModalEl.querySelector('form');
        var $subscribeFormSubmitBtn = subscribeModalEl.querySelector('.email-subscription-modal-js');
        var $subscribeModalCloseBtn = subscribeModalEl.querySelector('.modal-close-js');
        var $subscribeModalBackground = subscribeModalEl.querySelector('.modal-background');
        var $subscribeModalNavBtn = [].slice.call(document.querySelectorAll('.subscribe-btn-js'),0);

        // Show the subscription form if it has not been shown yet

        if (subscribeSubmit == 0 && subscribeClose == 0 && window.innerWidth > 1260) {
          setTimeout(function() {
            subscribeModalOpen('auto');
          }, 30000);
        }

        $subscribeModalNavBtn.forEach(function(item) {
          item.addEventListener('click', function(e) {
            e.preventDefault();
            subscribeModalOpen('menu');
          });
        });

        // Submit subscribe form
        $subscribeFormSubmitBtn.addEventListener('click', function(e) {
          e.preventDefault();
          subscribeFormSubmit();
        });

        $subscribeForm.addEventListener('submit', function(e) {
          e.preventDefault();
          subscribeFormSubmit();
        });

        // Close subscribe modal
        $subscribeModalCloseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          subscribeModalClose();
        });

        $subscribeModalBackground.addEventListener('click', function(e) {
          e.preventDefault();
          subscribeModalClose();
        });

        // customMobileMenu();
        slideoutInit();
        initSearchBlock();
        initSearchBlockTop();
        initGoToUp();


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function removeExcessTagsForMobile() {
          var classWidget = ".blocks-from-sidebar .feature-tag.tag-widget-";

          if ($(classWidget + "home").length > 0) {
            classWidget += "home";
          } else if ($(classWidget + "category").length > 0) {
            classWidget += "category";
          } else if ($(classWidget + "single").length > 0) {
            classWidget += "single";
          } else if ($(classWidget + "tag_page").length > 0) {
            classWidget += "tag_page";
          } else {
            return;
          }

          var height = $(classWidget).height();

          if (height && height > 340) {
            while (height > 343) {
              $(".feature-tags-block .tagcloud a:last-child").remove();
              height = $(classWidget).height();
            }
          }
        }

        /**
         * JavaScript to be fired on all pages, after page specific JS is fired
         * for mobile footer
         */
        function initXsmallFooterLinks() {
          var footerSections = [].slice.call(document.querySelectorAll('footer .section-nav .title'), 0);

          footerSections
            .forEach(function(element) {
              element.addEventListener("click", function(event) {
                event.preventDefault();
                var section = element.parentElement;
                section.classList.toggle("open");
              });
            });
        }

        initXsmallFooterLinks();

        removeExcessTagsForMobile();

        $(".thunderbolt-close-button").click(function() {
          $(".thunderbolt-wrap").slideUp(function() {
            $(this).hide();
          });
          $(".pc-navigation").animate({ top: 0 }, 400);
          $.cookie("thunderboltBlog", $("#thunderbolt-create-time").val(), {
            expires: 9999,
            path: "/"
          });
          $("#text-post").removeClass("post-thunderbolt-open");
        });

        // added class for create events (by click in Google Analytics)
        $(".thunderbolt-text").find("a")
          .addClass("thunder-bolt-link")
          .attr("target", "_blank");

        // add class for link at post
        $("#text-post a").each(function() {
          $(this).addClass("post-link");
        });
      }
    },

    // Home page
    "home": {
      init: function() {
        // JavaScript to be fired on the home page

        var $moreBtn = $("#show-more-btn-js");
        var $itemsBlock = $("#list-articles-js");
        var templateItems = _.template($("#items-template").html());
        var offset = 10;

        var dataPost = {
          categories: categories,
          offset: offset,
          exclude: exclude
        };

        $moreBtn.on("click", function(e) {
          e.preventDefault();
          var $this = $(this);

          if ($this.prop("disabled") !== "disabled") {
            $this.prop("disabled", true);
            var topOffsetBefore = window.pageYOffset;

            jxAction("get_post_home", dataPost, function(data) {
              $itemsBlock.append(templateItems({items: data.posts}));
              window.scrollTo(0, topOffsetBefore);

              var countPost = data.posts.length;

              if (countPost < 5) {
                $this.hide();
              }

              $this.prop("disabled", false);
              dataPost.offset += 5;
            });
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    "search": {

      finalize: function() {
        // Load results search

        function getQueryVariable(variable) {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (decodeURIComponent(pair[0]) === variable) {
              return decodeURIComponent(pair[1]);
            }
          }
        }

        var options = {
          postsMax: 0
        };

        var $itemsBlock = $("#load-results");
        var $moreBtn = $("#show-more-results-js");
        var templateItems = _.template($("#items-template").html());

        var dataPost = {
          s: getQueryVariable("s"),
          offset: 0,
          postsLoad: 0
        };

        $moreBtn.click(function(e) {
          e.preventDefault();
          var topOffsetBefore = window.pageYOffset;

          if (dataPost.offset === 0) {
            dataPost.offset = Number($(this).data("per-page"));
          }

          if (options.postsMax === 0) {
            options.postsMax = Number($(this).data("posts-max"));
          }

          if (dataPost.postsLoad === 0) {
            dataPost.postsLoad = Number($(this).data("posts-load"));
          }

          jxAction("load_resalts_search", dataPost, function(data) {
            $itemsBlock.append(templateItems({items: data.posts}));
            window.scrollTo(0, topOffsetBefore);
            dataPost.offset += dataPost.postsLoad;

            if (dataPost.offset >= options.postsMax) {
              $moreBtn.hide();
            }

          });

        });
      }

    },
    // About us page, note the change from about-us to about_us.
    "about": {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        var valid = 0;

        setTimeout(function() {
          var captcha = $('#g-recaptcha-response').val();

          jxAction('verify_captcha', {
            captcha: captcha
          }, function(data) {
            valid = data.response.status;
          });
        }, 3000);

        $('#send').click(function(e) {
          e.preventDefault();

          $('#send').prop('disabled', true).text('Sending...');

          var form = $('.about-form');
          var type = form.find('.type-feedback').val();
          var first_name = form.find('.firstname').val();
          var last_name = form.find('.lastname').val();
          var email = form.find('.email').val();
          var message = form.find('.message').val();

          jxAction('send_feedback_about', {
            type: type,
            first_name: first_name,
            last_name: last_name,
            email: email,
            message: message,
            valid: valid
          }, function(data) {

            form.find('.error').removeClass('error');

            if (data.response.status === 3) {

              $('.error-message').text(data.response.fields[0].message).show();
              data.response.fields.forEach(function(value) {
                form.find('.' + value.field).addClass('error');
              });

            } else if (data.response.status === 2) {
              $('.error-message').text(data.response.message).show();
              form.find('.email').addClass('error');
            } else if (data.response.status === 1) {
              form.find('.firstname').val('');
              form.find('.lastname').val('');
              form.find('.email').val('');
              form.find('.message').val('');

              form.find('.form-fields').hide();
              form.find('.thank-you').show();
            }

            $('#send').prop('disabled', false).text('Send Message');

          });
        });
      }
    },

    "single_post": {
      init: function() {
        $(".open-modal.share-btn").on("click", function(e) {
          modalIsOpen = true;
          e.preventDefault();
          var modal = $(this).data("modal");
          $("." + modal).show();
          // $("html").addClass("is-clipped");
        });

        $(".nwx-modal .close").click(function(e) {
          modalIsOpen = false;
          e.preventDefault();
          $(".nwx-modal").hide();
          // $("html").removeClass("is-clipped");
        });

        $(".subscribe-btn-js").on("click", function() {
          modalIsOpen = true;
        });
      },
      finalize: function() {
        initSocialShareButtons();

        function insertSwipeBlockForMobile() {
          var $tables = $("table:not(.tablepress)");
          $tables.wrap("<div class='table-wrapper'></div>");
          $(
            "<div class='swipe-block'>" +
            "<div class='swipe-icon'></div>" +
            "<div class='swipe-text'>Swipe left to see the full sheet</div>" +
            "</div>"
          ).insertBefore(".table-wrapper");
        }

        var copyLinkEl = document.querySelector('.copy-link-js');
        if (copyLinkEl) {
          copyLinkEl.addEventListener('click', copyLink);
        }

        $(".bottom-button-subscribe").on("click", function() {
          openSubscribeModal();
        });

        /* function setHeightToSidebar() {
           var isMoreThanTablet = window.innerWidth >= 1260;
           var heightArticleHasChanged = article.offsetHeight !== articleHeight;
           if (isMoreThanTablet && heightArticleHasChanged) {
             articleHeight = article.offsetHeight;
             // move potentially hard operation to requestAnimationFrame
             requestAnimationFrame(function() {
               rightSidebar.style.height = articleHeight + 'px';
             });
           }
         }

         // block for correct work sticky right-sidebar without global rebuild layout
         var article = document.querySelector('article.post');
         var articleHeight = 0;
         var rightSidebar = document.querySelector('.sidebar-right-js');

         setHeightToSidebar();
         window.addEventListener('resize', setHeightToSidebar);*/

        $("#dcl_comment_btn").click(function() {
          $("#dcl-hidden-div")
            .css("border-top", "0")
            .css("border-bottom", "0")
            .css("display", "block");
        });

        var tags = $("#more_post_tags");
        if (tags.length) {
          $("#more_post_tags").hide();
        }

        $("#more_post_tags_button").click(function(e) {
          e.preventDefault();
          $(this).hide();
          $("#more_post_tags").show();
        });

        insertSwipeBlockForMobile();

        var $commentsSection = $('#comments'),
          $showCommentsBlock = $("#show-comments-button");

        if (commentsIsAllowed !== '1') { // option: comments are not allowed
          $showCommentsBlock.hide();
        } else {
          $commentsSection.hide();

          $showCommentsBlock.on('click', function() {
            $commentsSection.show();
            $(this).hide();
          });
        }
      }
    },

    "author": {
      init: function() {
        var $moreBtn = $("#show-more-btn-js");
        var $itemsBlock = $("#list-articles-js");
        var $showDescr = $("#show-descr-js");
        var templateItems = _.template($("#items-template").html());
        var params = {
          authorID: authorID,
          page: page,
          category: 0
        };

        if (countPosts <= 10) {
          $moreBtn.hide();
        }


        $moreBtn.on("click", function(e) {
          e.preventDefault();
          params.page++;
          var topOffsetBefore = window.pageYOffset;

          jxAction("get_post_author", params, function(data) {

            $itemsBlock.append(templateItems({ items: data.posts }));
            window.scrollTo(0, topOffsetBefore);

            if (data.posts.length < 5) {
              $moreBtn.hide();
            } else {
              $moreBtn.show();
            }

          });

        });

        $showDescr.on("click", function(e) {
          e.preventDefault();

          $(".author-descr").toggleClass("is-block");
        });

        $(".author-descr a:not([href*=\"netwrix\"])").attr("rel", "nofollow noopener");

      }

    },

    "tag": {
      init: function() {
        var $moreBtn = $("#show-more-btn-js");
        var $itemsBlock = $("#list-articles-js");
        var templateItems = _.template($("#items-template").html());
        var offset = 10;

        $moreBtn.on("click", function(e) {
          e.preventDefault();
          var $this = $(this);

          if ($this.attr("disabled") !== "disabled") {
            $this.attr("disabled", true);
            var topOffsetBefore = window.pageYOffset;

            var data = {
              tag: slugTag,
              offset: offset
            };

            jxAction("get_post_tag", data, function(data) {
              $itemsBlock.append(templateItems({items: data.posts}));
              window.scrollTo(0, topOffsetBefore);

              postsTag -= data.posts.length;

              if (postsTag <= 0) {
                $moreBtn.hide();
              }

              $this.attr("disabled", false);
              offset += 5;
            });
          }
        });
      }
    },

    "category": {
      init: function() {
        // JavaScript to be fired on the home page, after the init JS
        var $moreBtn = $("#show-more-btn-js");
        var $itemsBlock = $("#list-articles-js");

        var offset = 21;
        var category = Number($moreBtn.data("category"));
        var templateItems = _.template($("#items-template").html());
        var dataPost = {
          offset: offset,
          categoryId: category
        };

        $moreBtn.on("click", function(e) {
          e.preventDefault();
          var $this = $(this);

          if ($this.attr("disabled") !== "disabled") {
            $this.attr("disabled", true);
            var topOffsetBefore = window.pageYOffset;

            jxAction("get_post", dataPost, function(data) {
              var countOfData = data.posts.length;

              $itemsBlock.append(templateItems({items: data.posts}));
              window.scrollTo(0, topOffsetBefore);

              if (countOfData < 10) {
                $this.hide();
              } else {
                $this.attr("disabled", false);
                dataPost.offset += 10;
              }
            });
          }

        });
      },

      finalize: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");

    },
    checkCaptcha: function() {


    },
    checkEmail: function(email) {
      var returnValue;
      $.ajax({
        type: "POST",
        url: "https://www.netwrix.com/additionalservice/checkemail",
        cache: false,
        dataType: "json",
        async: false,
        data: {
          email: email
        },
        success: function(data) {
          returnValue = data.status;
        }
      });

      // @TODO Check!!!
      return returnValue;
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

